import { Card, Dropdown, FloatButton, Pagination, Tooltip } from 'antd'
import React from 'react'
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { galeryAction } from 'src/store/Slices/Administrator/GalerySlice';
import { formatIsoToDateNew, formatIsoToTime } from 'src/components/helpers/formateDate'

const MobilePassages = ({
    servicesList,
    servicesListLoading,
    page,
    setPage,
    setPageSize,
}) => {

    const dispatch = useDispatch()
    const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',]

    const newDate = new Date()

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Pagination
                    defaultCurrent={page}
                    pageSize={20}
                    showSizeChanger={false}
                    current={page}
                    onChange={(page, pageSize) => {
                        dispatch(passagesAction({ flag: 'get', value:{
                            DateFrom: `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${months[newDate.getMonth()]} ${newDate.getFullYear()} 00:00:00`,
                            DateTo: `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${months[newDate.getMonth()]} ${newDate.getFullYear()} 23:59:59` }
                        }))
                        setPage(page)
                        setPageSize(pageSize)
                    }}
                    total={servicesList?.data?.value?.totalCount}
                    page={page}
                />
                {servicesList?.data?.value?.rows.map(element => {
                    return (
                        <Card
                            loading={servicesListLoading}
                            title={`Проход №: ${element.userId}`}
                            style={{ width: 330, marginTop: 16 }}
                            key={element.id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div>ФИО:</div>
                                    <div>Телефон:</div>
                                    <div>Тип:</div>
                                    <div>Дата:</div>
                                </div>
                                <div>
                                    <div>{element?.userFio ? <Tooltip title={element?.userFio}>{element?.userFio.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.userPhone ? <Tooltip title={element?.userPhone}>{element?.userPhone.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.date ? <Tooltip title={formatIsoToDateNew(element.date) + ' ' + formatIsoToTime(element.date)}>{formatIsoToDateNew(element.date) + ' ' + formatIsoToTime(element.date)}</Tooltip> : '-'}</div>
                                    <div>{element?.status ? <Tooltip title={element?.status}>{element?.status.slice(0, 15)}</Tooltip> : '-'}</div>
                                </div>
                            </div>
                        </Card>
                    )
                })}
            </div>
        </>
    )
}

export default MobilePassages